import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img className='m-52 mx-auto' src="https://th.bing.com/th/id/OIP.gk7ERwhFPqN0Rbl3kQ-pJwHaEK?pid=ImgDet&rs=1" alt="" />
        </div>
    );
};

export default NotFound;